// extracted by mini-css-extract-plugin
var _1 = "RentalPortalProvenanceChip-moduleRentalPortalProvenanceChip__vtzMA Tag-moduleTag__FLr9H";
export { _1 as "RentalPortalProvenanceChip" }
